module.exports = __webpack_public_path__ + "static/img/fangdichan1.e95410a6.png";